exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NavigationItems__NavigationItems___yd_d {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-flow: column;\n    justify-content: space-around;\n    position: relative;\n    top: 100px;\n    left: 0;\n    height: 100%;\n    width: 100%;\n}\n\n@media (min-width: 1441px){\n    .NavigationItems__NavigationItems___yd_d {\n        margin-top: 0;\n        position: static;\n    }\n}\n", ""]);

// Exports
exports.locals = {
	"NavigationItems": "NavigationItems__NavigationItems___yd_d"
};